export const appConfig = () => ({
	env: process.env.NODE_ENV,
	env_file: process.env.REACT_APP_ENV_FILE,
	assets_host: process.env.REACT_APP_ASSETS_HOST,
	// api_urls: String("https://api.reserve-donkin-leads.ru/dentolo/v2,https://api.donkin-leads.ru/dentolo/v2").split(",")
	api_urls: String(process.env.REACT_APP_API_URLS).split(",")
});

export type AppConfig = ReturnType<typeof appConfig>;
